import React, { useState, useEffect } from "react";

const Navbar = ({ toggleTheme }) => {
    const [isOpen, setIOpen ] = useState(false);
    const [isScroll, setIsScroll] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setIsScroll(window.scrollY > 100);
        });
    },[]);

    const toggleNav = () => {
        if (isOpen) {
            setIOpen(false);
        } else {
            setIOpen(true);
        }
    }


    // const [width] = useWindowSize();
    return (
        <header className={isScroll ? 'header scroll-header' : 'header'} id="header">
            <nav className="nav container">
                <a href="#home" className="nav__logo">Shafnas</a>
                <div className={isOpen ? 'nav__menu show-menu' : 'nav__menu'} id="nav-menu">
                    <ul className="nav__list grid">
                        <li className="nav__item">
                            <a href="#home" className="nav__link" onClick={toggleNav}>
                                <i className="uil uil-estate nav__icon"></i> Home
                            </a>
                        </li>
                        <li>
                            <a href="#about" className="nav__link" onClick={toggleNav}>
                                <i className="uil uil-user nav__icon"></i> About
                            </a>
                        </li>
                        <li>
                            <a href="#skills" className="nav__link" onClick={toggleNav}>
                                <i className="uil uil-file-info-alt nav__icon"></i> Skills                          
                            </a>
                        </li>
                        <li>
                            <a href="#services" className="nav__link" onClick={toggleNav}>
                                <i className="uil uil-briefcase-alt nav__icon"></i> Services
                            </a>
                        </li>
                        <li>
                            <a href="#portfolio" className="nav__link" onClick={toggleNav}>
                                <i className="uil uil-scenery nav__icon"></i> Portfolio
                            </a>
                        </li>
                        <li>
                            <a href="#contact" className="nav__link" onClick={toggleNav}>
                                <i className="uil uil-message nav__icon"></i> Contact
                            </a>
                        </li>
                    </ul>
                    <i className="uil uil-times nav__close" id="nav-close" onClick={toggleNav}></i>
                </div>

                <div className="nav__btns">
                    {/* theme change button */}
                    <div className="nav__toggle" id="nav-toggle">
                        <span id="checkbox">
                            <input id="ckeckbox-element" type="checkbox" onChange={(event) => toggleTheme(event)}/>  
                            <i className="uil uil-moon change-theme" id="change-theme"></i>
                        </span>
                        <i className="uil uil-apps" id="app-btn" onClick={toggleNav}></i>
                    </div>
                </div>
            </nav>
        </header>
    )
}

export default Navbar;